import React from 'react'
import styled from 'styled-components'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from 'swiper'
import { useWindowSize } from '@/lib/use-hooks/use-window-size'
SwiperCore.use([Pagination, Navigation])
import { createResource, useResource } from '@/lib/i18n'
import { Animation, Reveal } from 'react-genie'
import Image from 'next/image'
import LazyLoad from 'react-lazyload'
import Link from 'next/link'
import { MediaList } from '@/lib/constant'

const resource = createResource({
  en: {
    title: 'As featured on',
  },
  id: {
    title: 'Seperti yang Ditampilkan Pada',
  },
})

const AssociatedMedia = () => {
  const { t } = useResource(resource)
  const { width } = useWindowSize()
  return (
    <MediaStyle>
      <h2 className="title">{t('title')}</h2>
      <div className="items" style={{ width: width >= 1000 ? 'auto' : '360px' }}>
        {width >= 1000 && (
          <div className="prevButton">
            <Image
              src={'/images/home/black.png'}
              alt="honours"
              width={40}
              height={40}
              quality={85}
              priority
              placeholder="empty"
            />
          </div>
        )}
        {/* {width >= 1000 && ( */}
        <Swiper
          className="myswiper"
          spaceBetween={10}
          slidesPerView={1}
          navigation={
            width >= 1000
              ? {
                  nextEl: '.nextButton',
                  prevEl: '.prevButton',
                }
              : false
          }
          breakpoints={{
            '@0.00': {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            '@1.00': {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            '@1.20': {
              slidesPerView: 3,
              spaceBetween: 16,
            },
            '@1.50': {
              slidesPerView: 4,
              spaceBetween: 16,
            },
          }}
          pagination={width >= 1000 ? false : { clickable: true, dynamicBullets: true, dynamicMainBullets: 3 }}
        >
          {MediaList.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="item">
                <Link href={item.url} target="_blank" rel="nofollow" className="item-img">
                  <LazyLoad>
                    <div className="img">
                      <img src={item.logo} alt="honours" className="media-img" />
                    </div>
                  </LazyLoad>
                </Link>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        {width >= 1000 && (
          <div className="nextButton">
            <Image
              src={'/images/home/black-right.png'}
              alt="honours"
              width={40}
              height={40}
              quality={85}
              priority
              placeholder="empty"
            />
          </div>
        )}
      </div>
    </MediaStyle>
  )
}

export default AssociatedMedia

const MediaStyle = styled.div`
  @media only screen and (max-width: 1000px) {
    margin: 64px auto 0;
    text-align: center;
    max-width: 1440px;
    .title {
      font-size: 24px;
      font-family: Roboto-Medium, Roboto;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.87);
      line-height: 28px;
      margin-bottom: 20px;
    }
    .items {
      display: flex;
      justify-content: center;
      margin: 0 auto;
      .item {
        width: 249px;
        height 100px;
        background: #fff;
        box-shadow: 0px 4px 12px 2px rgba(0, 0, 0, 0.1);
        border-radius: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 12px auto 60px;
        .img {
          max-width: 225px;
          max-height: 46px;
          flex: none;
          line-height: 1;
          .media-img {
            width: 100%;
            height: auto;
          }
        }
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    padding: 104px 146px 0px;
    text-align: center;
    max-width: 1440px;
    margin: 0 auto;
    .title {
      font-size: 36px;
      font-family: Roboto-Medium, Roboto;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.87);
      line-height: 48px;
      margin-bottom: 36px;
    }
    .items {
      display: flex;
      justify-content: center;
      .nextButton, .prevButton {
        width: 40px;
        height 120px;
        display: flex;
        align-items: center;
        cursor: pointer;
        div {
          width: 40px !important;
          position: relative;
          top: 8px;
        }
      }
      .myswiper {
        padding: 0 12px;
      }
      .item {
        width: 249px;
        height 100px;
        background: #fff;
        box-shadow: 0px 4px 12px 2px rgba(0, 0, 0, 0.1);
        border-radius: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 12px 0;
        padding: 0 12px;
        .img {
          max-width: 225px;
          max-height: 46px;
          flex: none;
          line-height: 1;
          .media-img {
            width: 100%;
            height: auto;
          }
        }
      }
    }
  }
`
